module.exports = __webpack_public_path__ + "static/media/lcloudy_n.7d0cd93a.svg";